<template>
  <smd-one-col-layout>
    <h2 class="ta-center">{{ header }}</h2>
    <p v-if="subHeader" class="ta-center mt-s">{{ subHeader }}</p>

    <section class="mtb-l">
      <div v-for="(step, stepIndex) in steps"
           :key="stepIndex">
        <div class="step">
          <div class="image-container">
            <img :src="step.image"
                 :alt="step.step"
                 class="d-block m-auto">
          </div>
          <div class="details">
            <p class="mb-xs fw-bold">{{ step.step }}</p>
            <p>{{ step.description }}</p>
          </div>
        </div>
        <i v-if="stepIndex < steps.length - 1" class="ns-icon-caret-down"></i>
      </div>
    </section>

    <smd-btn class="d-block m-auto"
             section="4"
             variant="blue-enabled"
             @click="buttonClicked">
      {{ button.text }}
    </smd-btn>
  </smd-one-col-layout>
</template>

<script>
  export default {
    name: 'StepsModal',
    props: {
      header: {type: String, required: true},
      subHeader: {type: String, default: null},
      /**
       * An array of object with props of:
       *  image (string)
       *  step (string)
       *  description (string)
       */
      steps: {type: Array, required: true},
      /**
       * props:
       *  text (string)
       *  func (function)
       */
      button: {type: Object, required: true},
    },
    methods: {
      buttonClicked() {
        if (this.button.func) {
          this.button.func();
        }

        this.$modal.close();
      },
    },
  }
</script>

<style lang="scss" scoped>
  .step {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .image-container {
    width: 25%;
    min-width: 104px;
    margin-right: space(m);
  }

  i {
    display: block;
    margin: space(m) auto;
    text-align: center;
    color: color(gray, text);
  }
</style>
